import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import useWindowSize from '../../_hooks/useWindowSize';

const sx = {
    fontSize: 22
}

const CardContainer = (props, {type = 1}) => {
    const {
        elevation=0,
        cardActions = false,
        title = false,
        subtitle = false,
        customSubheaderProps = {},
        border = false,
        customHeader = false,
        children,
        padding,
        className,
        sx = {},
        cardHeaderSx = {},
        contentSx = {},
        contentClasses = "",
        actionsSx = {},
        bgColor = 'f8fafc',
        primaryHeader = false,
        hover = true
    } = props;


    const {isMobile} = useWindowSize();

    const hasPadding = padding && !isMobile ? '16px' : padding && isMobile ? '6px' : !padding && '0px';
    const generalPadding = !isMobile ? '16px' : '6px';
    let primaryColours = {

    };

    if(primaryHeader){
        primaryColours = {
            backgroundColor: (theme) => theme.palette.primary.main,
            color: (theme) => theme.palette.primary.contrastText
        }
    }

    return (
        <Card 
            ref={props?.ref || null}
            className={className}
            sx={{
                border: `${border ? '1px' : '0px'} solid #eeeeee`,
                ...(hover && {
                    '&:hover': {
                        boxShadow: 'rgba(32, 40, 45, 0.08) 4px 8px 22px 4px'
                    },
                }),
                backgroundColor: type == 1 ? bgColor : 'initial',
                ...sx,
        }} elevation={elevation}
        >

            {title && (
                <>
                    <CardHeader 
                        sx={{
                            ...primaryColours,
                            p: generalPadding,
                            '& .MuiCardHeader-content': {
                                display: 'flex',
                                justifyContent: 'space-between'
                            },
                            ...cardHeaderSx,
                        }}
                        className={`${!isMobile ? '' : ''} d-flex`}
                        title={
                            !customHeader ? (
                                <Typography component="h3" variant="h3" sx={sx}>{title}</Typography>
                            ) : title
                        }
                        subheader={subtitle}
                        subheaderTypographyProps={{
                            // width: '100%'
                            color: (theme) => primaryHeader ? theme.palette.primary.contrastText : 'initial',
                            ...customSubheaderProps

                        }}

                    />

                    <Divider/>
                </>
            )}
            <CardContent className={contentClasses} sx={{p: hasPadding, ...contentSx}}>
                {children}
            </CardContent>

            {cardActions && (
                <CardActions sx={actionsSx}>
                    {cardActions}
                </CardActions>
            )}
        </Card>
    )
}

export default CardContainer